export const SET_CURRENT_TIME = 'SET_CURRENT_TIME';
export const SET_SERVER_TIME_OFFSET = 'SET_SERVER_TIME_OFFSET';

const setCurrentTime = time => ({
  type: SET_CURRENT_TIME,
  time,
});

export const startTicker = dispatch => {
  const now = new Date().getTime();
  dispatch(setCurrentTime(now));
  // correct for skew
  const timeUntilNextSec = 1000 - (now % 1000);
  setTimeout(() => {
    dispatch(startTicker);
  }, timeUntilNextSec);
};

export const setServerTimeOffset = offset => ({
  type: SET_SERVER_TIME_OFFSET,
  offset,
});



// WEBPACK FOOTER //
// ./src/actions/time.js